import { PagedResponse } from "@/types/PagedResponse";
import { PageRequest } from "@/types/pagination";
import { Seguro, SeguroLista } from "@/types/Seguro";
import { Sort } from "@/types/sort";
import { buildFilter } from "@/utils/filter.util";
import { formatDate } from "@/utils/DateUtils";
import axios, { AxiosPromise } from "axios"; 

export const findFichasPorAno = (ano: string|number, seguradora?: string, corretor?: string): AxiosPromise<any[]> => {
    return findGroupByPeriod(1, ano, 12, ano, seguradora, corretor);
}

export const findQtdFichasPorAnoMes = (ano: string|number, mes: string|number): AxiosPromise<number> => {
    return axios.get(`/api/seguro/find-by-ano-mes/${ano}/${mes}`);
}

export const findGroupByPeriod = (mesInicial: string|number, anoInicial: string|number, mesFinal: string|number, anoFinal: string|number, seguradora?: string, corretor?: string): AxiosPromise<any> => {
    if (!seguradora || seguradora === null) seguradora = '';
    if (!corretor || corretor === null) corretor = '';
    return axios.get(`/api/seguro/find-by-period?mesInicial=${mesInicial}&anoInicial=${anoInicial}&mesFinal=${mesFinal}&anoFinal=${anoFinal}&seguradora=${seguradora}&corretor=${corretor}`);
}

export const findChartPorSeguradora = (): AxiosPromise<any> => {
    return axios.get(`/api/seguro/chart-por-seguradora`);
}

// Lista da tela de seguros (resposta enxuta)
export const findLista = (searchParams?: string, pagination?: PageRequest, sort?: Sort): AxiosPromise<PagedResponse<SeguroLista>> =>
    axios.get(`/api/seguro/lista`, {
        params: {
            search: searchParams,
            ...sort,
            ...pagination
        },
        paramsSerializer: { indexes: null }
    });

export const findFichas = (searchParams?: string, pagination?: PageRequest, sort?: Sort): AxiosPromise<PagedResponse<Seguro>> => 
    axios.get(`/api/seguro`, {
        params: {
            search: searchParams,
            ...sort,
            ...pagination
        },
        paramsSerializer: { indexes: null }
    });

// Só o total de seguros para o filtro (painel inicial)
export const contar = (searchParams: string): AxiosPromise<number> =>
    axios.get(`/api/seguro/contar`, { params: { search: searchParams } });

export const contarVigentes = (): AxiosPromise<number> => {
    let currentDate = formatDate(new Date());
    return contar(`vigenciaInicial=le="${currentDate}";vigenciaFinal=ge="${currentDate}"`);
}

export const autoComplete = (search: string): AxiosPromise<PagedResponse<Seguro>> =>
    findFichas(search ? buildFilter(['segurado.nome','segurado.cpfCnpj','descricao','placa','seguradora.nome'])(search) : '',
    {page: 0, size: 20},{sort: 'segurado.nome'});

export const getByCodigo = (codigo: string): AxiosPromise<Seguro> => 
    axios.get(`/api/seguro/${codigo}`);    

export const create = (ficha: Seguro): AxiosPromise<Seguro> => 
    axios.post(`/api/seguro`, ficha); 

export const update = (ficha: Seguro, id: string): AxiosPromise<Seguro> => 
    axios.put(`/api/seguro/${id}`, ficha); 

export const remove = (codigo: string): AxiosPromise<void> => 
    axios.delete(`/api/seguro/${codigo}`);     

export const findSegurosVigentesAgrupadoPorTipo = (): AxiosPromise<any> => {
    return axios.get(`/api/seguro/vigentes/por-tipo`);    
}

export type ComissaoMes = { mes: number; seguradora: string; quantidade: number; premioLiquido: number; comissao: number };

export const findComissoes = (ano: number, corretor?: string): AxiosPromise<ComissaoMes[]> =>
    axios.get(`/api/seguro/comissoes/${ano}`, { params: { corretor } });
